import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import NewsDetail from "../pages/news/detail";
import ServicePage from "../pages/services/page";
import ProjectPage from "../pages/projects/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/news/:id",
    element: <NewsDetail />,
  },
  {
    path: "/services/:slug",
    element: <ServicePage />,
  },
  {
    path: "/projects/:id",
    element: <ProjectPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
